import { useMemo } from 'react';

import { demoWoopWorkloadSpec } from '@cast/fixtures';
import { WorkloadSpecResponse } from '@cast/types';

import { useIsWoopDemoMode } from 'features/workload-optimization';
import {
  UseWorkloadSpecQueryArgs,
  useWorkloadSpecQuery,
} from 'hooks/queries/workload-optimization';
import { useDataOrFixture } from 'hooks/useDataOrFixture';

export const useWoopWorkloadSpec = (queryArgs: UseWorkloadSpecQueryArgs) => {
  const isWoopDemoMode = useIsWoopDemoMode();

  const queryResult = useWorkloadSpecQuery({
    ...queryArgs,
    enabled: !isWoopDemoMode && queryArgs.enabled,
  });

  const demoWorkloadsFixture = useMemo(
    () => () =>
      demoWoopWorkloadSpec().then((fixture) => {
        const workloadId = queryArgs.workloadId;
        const data = fixture.find(({ id }) => id === workloadId);
        return {
          ...data,
        } as WorkloadSpecResponse;
      }),
    [queryArgs.workloadId]
  );

  const workloadDataOrFixture = useDataOrFixture(
    queryResult.data,
    demoWorkloadsFixture,
    isWoopDemoMode
  );

  return { ...queryResult, data: workloadDataOrFixture };
};
